import {
  EXTENDED_WARRANTY_2YEAR_SKU,
  EXTENDED_WARRANTY_3YEAR_SKU,
} from '@/app/[locale]/store/_consts';
import WarrantySelectionEnum from '@/app/enums/WarrantySelectionEnum';

export default function getExtendedWarrantySku(
  selection: WarrantySelectionEnum | undefined,
): string | null {
  switch (selection) {
    case WarrantySelectionEnum.TwoYear:
      return EXTENDED_WARRANTY_2YEAR_SKU;
    case WarrantySelectionEnum.ThreeYear:
      return EXTENDED_WARRANTY_3YEAR_SKU;
    default:
      return null;
  }
}
